/* ─────────────────────────────────────────────────────────────────
   localization-form.js — <ae-localization-form> (snippets/localization-form.liquid)

   Progressive enhancement for Shopify's standard localization form. Without
   this file the form is a plain <select> + "Update" button that posts to
   /localization, and that is the baseline that must always work.

   With it:
     • the "Update" button is hidden (CSS: ae-localization-form:defined);
     • picking with a mouse or finger submits straight away;
     • a keyboard change (arrow keys on a closed select change the value in some
       browsers) does NOT submit — it reveals "Update" instead, so the page never
       reloads while someone is arrowing through the list. Enter submits.

   Self-contained: no dependency on global.js or Dawn's localization-form.
   ───────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (!('customElements' in window) || customElements.get('ae-localization-form')) return;

  var NON_CHANGING_KEYS = ['Tab', 'Shift', 'Control', 'Alt', 'Meta', 'Escape'];

  class AeLocalizationForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.select = this.querySelector('select');
      if (!this.form || !this.select || this.initialValue !== undefined) return;

      this.initialValue = this.select.value;
      this.keyboard = false;

      this.select.addEventListener('pointerdown', () => { this.keyboard = false; });
      this.select.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (this.select.value !== this.initialValue) this.submit();
          return;
        }
        if (NON_CHANGING_KEYS.indexOf(event.key) === -1) this.keyboard = true;
      });
      this.select.addEventListener('change', () => {
        var dirty = this.select.value !== this.initialValue;
        if (dirty && !this.keyboard) {
          this.submit();
          return;
        }
        this.classList.toggle('is-dirty', dirty);
      });

      // Back button (bfcache) after a submit: restore the idle state.
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        this.submitting = false;
        this.keyboard = false;
        this.select.value = this.initialValue;
        this.classList.remove('is-loading', 'is-dirty');
        this.form.removeAttribute('aria-busy');
      });
    }

    submit() {
      if (this.submitting) return;
      this.submitting = true;
      this.classList.add('is-loading');
      this.form.setAttribute('aria-busy', 'true');
      this.form.submit();
    }
  }

  customElements.define('ae-localization-form', AeLocalizationForm);
})();
